import React from 'react';
import { motion } from 'framer-motion';

const Notice = () => {
  return (
    <section className="bg-yellow-50 py-8 px-6 border-t-4 border-yellow-400">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center space-y-4"
        >
          <h3 className="text-lg font-semibold text-gray-800 flex items-center justify-center gap-2">
            <span className="text-yellow-600">⚠️</span>
            Notice: This website is created only for student practice.
          </h3>
          <p className="text-gray-700 leading-relaxed max-w-4xl mx-auto">
            Account4Web experts have not fixed technical issues here – so you can clearly see the real work level of students. 
            Almost 80% of the website is perfect, and the remaining 20% is polished by experts in final projects.
          </p>
          <p className="text-gray-700 flex items-center justify-center gap-2">
            <span className="text-green-600">🔒</span>
            We never share any client website made under this offer with others – your project privacy is 100% safe.
          </p>
          <p className="text-gray-700">
            <span className="text-blue-600">👉</span>
            <a 
              href="https://projects.azaansuperpc.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 font-medium underline ml-2"
            >
              Check Offer
            </a>
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Notice;